module.exports = __webpack_public_path__ + "static/img/metal.cdf4f90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fx-software/pack/metal.png
// module id = UYOc
// module chunks = 13